module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-detail-header"
  }, [_c('div', {
    staticClass: "pull-left page-detail-title"
  }, [_c('span', {
    staticClass: "page-detail-span"
  }, [_c('i', {
    staticClass: "fa fa-sitemap"
  }), _vm._v("\n              当前ZK集群 : " + _vm._s(_vm.zkCluster || '全部ZK集群') + "\n          ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.init
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "page-content",
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "全域当天执行数据",
      "type": "pie"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('Pie', {
    attrs: {
      "id": "domainProcessCount",
      "option-info": _vm.domainProcessCountOptionInfo
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "全域历史执行数据",
      "type": "line"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('MyLine', {
    attrs: {
      "id": "domainProcessHistory",
      "option-info": _vm.allDomainHistoryOptionInfo
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "失败率最高的Top10域",
      "type": "bar"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('Column', {
    attrs: {
      "id": "top10FailDomain",
      "option-info": _vm.top10FailDomainOptionInfo
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "稳定性最差的的Top10域",
      "type": "bar"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('Column', {
    attrs: {
      "id": "top10UnstableDomain",
      "option-info": _vm.top10UnstableDomainOptionInfo
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "域版本分布",
      "type": "pie"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('Pie', {
    attrs: {
      "id": "domainExecutorVersion",
      "option-info": _vm.domainExecutorVersionOptionInfo
    }
  })], 1)])], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-060315a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard_manage/domain_statistic.vue
// module id = 1372
// module chunks = 1